export const sliceLastFromString = ({
    str='',
    symbolToSlice,
}: {
    str: string;
    symbolToSlice: string;
}) => {
    const lastChar = str?.charAt(str.length - 1);
    if (lastChar === symbolToSlice) {
        return str.slice(0, -1);
    }
    return str;
};
